const scenarios = [
  {
    icon: 'ri-briefcase-line',
    title: '职场办公',
    description: '任务管理、日程安排、文档协作，一站式搞定日常工作，让办公更高效。',
    users: '职场白领、项目经理',
  },
  {
    icon: 'ri-pencil-ruler-2-line',
    title: '创意设计',
    description: '灵感捕捉、作品管理、项目追踪，帮助创意工作者专注创作本身。',
    users: '设计师、内容创作者',
  },
  {
    icon: 'ri-graduation-cap-line',
    title: '学习备考',
    description: '笔记整理、复习计划、进度追踪，让学习过程有条不紊，事半功倍。',
    users: '学生、考研群体',
  },
  {
    icon: 'ri-team-line',
    title: '团队协作',
    description: '任务分配、进度同步、知识共享，小团队的高效协作利器。',
    users: '5-20人小团队',
  },
  {
    icon: 'ri-store-2-line',
    title: '创业管理',
    description: '项目规划、资源统筹、目标追踪，助力创业者从0到1稳步前行。',
    users: '创业者、自由职业者',
  },
  {
    icon: 'ri-heart-pulse-line',
    title: '生活规划',
    description: '习惯养成、目标管理、时间记录，让每一天都过得充实有意义。',
    users: '对生活有追求的人',
  },
];

export default function ScenariosSection() {
  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold font-heading text-foreground-950">
            适用于多种<span className="text-accent-500">场景</span>
          </h2>
          <p className="mt-4 text-foreground-600 max-w-2xl mx-auto text-sm md:text-base">
            无论你是谁，在做什么，娜娜轻量版都能成为你的得力助手。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {scenarios.map((scenario, index) => (
            <div
              key={index}
              className="p-6 rounded-2xl bg-background-50 border border-background-200/70 hover:border-accent-300/60 transition-colors duration-200"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-xl bg-accent-100 text-accent-500 mb-4">
                <i className={`${scenario.icon} text-lg`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-950 mb-2">{scenario.title}</h3>
              <p className="text-sm text-foreground-600 leading-relaxed mb-4">{scenario.description}</p>
              <div className="flex items-center gap-2">
                <i className="ri-user-line text-xs text-accent-500"></i>
                <span className="text-xs text-foreground-500">{scenario.users}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}